import { TextInput } from "../Form";
import { Modal } from "../Modal";
import ChooseGroupArrow from "../../assets/icons/choose-group-arrow.svg";
import { useInfiniteQuery, useQuery } from "react-query";
import { fetchData } from "../../services/fetch";
import React from "react";
import { useDispatch } from "react-redux";
import { setGroup, setType,setTypeId } from "../../slices/publish";
import { truncateString } from "../../utils/truncate";
export default function ChooseGroupModal({
  oldgroup,
  isOpen,
  isChooseGroup,
  onClick,
  onClose,
  setGroup,
  onchangetype,
}) {
  const dispatch = useDispatch();
  const listInnterRef = React.useRef();
  const [search, setSearch] = React.useState("");
  const [groups, setGroups] = React.useState([]);
  const { isLoading, data } = useQuery({
    queryKey: ["get-persona-group"],
    queryFn: async ({ listall = 1 }) => {
      const res = await fetchData({
        url: `api/persona_group?listall=${listall}`,
      });
      return res.data;
    },
    // only calls the api when `chooseGroupModal` is set to true
    enabled: isOpen,
    onSuccess: (response) => {
      setGroups(response.groups);
    },
  });
  function onFilter(searchValue) {
    if (searchValue === "") {
      setGroups(data.groups);
    } else {
      const filtered = data.groups.filter(
        (group) =>
          group.name.includes(searchValue) || group.group_no === +searchValue
      );
      setGroups(filtered);
    }
  }
  return (
    <Modal
      isChooseGroup={isChooseGroup}
      isOpen={isOpen}
      width="592px"
      height="473px"
      boxClass="group-select-message-box"
    >
      <div className="px-4" style={{ marginTop: "27px", position: "relative" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            position: "absolute",
            right: 20,
            top: -7,
            transform: "rotate(45deg)",
          }}
          className="plus-icon"
          onClick={onClose}
        ></div>
        <div className="fs-25-px text-center font-ethno">グループ選択</div>
        <div className="mt-10-px d-flex justify-content-center">
          <TextInput
            className="h-40-px w-400-px"
            placeholder="グループ名やグループ番号にて検索"
            inputClass="pb-1"
            required
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => (e.keyCode === 13 ? onFilter(search) : " ")}
          ></TextInput>
        </div>
        <div className="" style={{ marginTop: "35px" }}>
          <div className="d-flex justify-content-center">
            <div className="d-flex fs-20-px text-primary text-center font-notosans-jp-medium w-100 ms-20-px">
              <div className="w-50" style={{ fontWeight: 500 }}>
                グループ名
              </div>
              <div className="w-50" style={{ fontWeight: 500 }}>
                グループ番号
              </div>
            </div>
          </div>

          <div
            className=" d-flex justify-content-center ms-20-px"
            style={{ marginTop: "13px" }}
          >
            <div
              className="overflow-auto hide-scroll w-100 "
              style={{ height: "260px" }}
              ref={listInnterRef}
            >
              {!isLoading &&
                groups?.map((group, i) => (
                  <div
                    className="text-word-wrap d-flex fs-20-px align-items-center text-center choose-group-list position-relative"
                    style={{
                      cursor: "pointer",
                      //cursor: "col-resize",
                      marginBottom: "12.5px",
                      color: "#FFFFFF",
                    }}
                    onClick={() => {
                      onClick();
                      onchangetype(group);
                      dispatch(setTypeId(""));
                      if(oldgroup?.group?.id==group?.id){
                        //old data
                      }
                      else {
                        setGroup(group);
                      }
                      dispatch(
                        setType({
                          persona_type_name: "",
                        })
                      );
                    }}
                  >
                    <div
                          className=" choose-arrow"
                          style={{ left: "10px", bottom: "15px" }}
                        >
                          <img
                            src={ChooseGroupArrow}
                            alt="choose-group-arrow"
                          />
                    </div>
                    {/* Group list */}
                    <div className="name">{group.name}</div>
                    <div className="groupno">{group.group_no}</div>
                    <div
                          className="choose-arrow ms-20-px"
                          style={{
                            bottom: "15px",
                            transform: "scaleX(-1)",
                          }}
                        >
                          <img
                            src={ChooseGroupArrow}
                            alt="choose-group-arrow"
                          />
                    </div>
                    
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
